import { focusField } from './focusUtils';

export const goToNextFocusable = ({
  current,
  to,
}: {
  current: string;
  to?: string;
}) => {
  const focusableElements = Array.from(
    document.querySelectorAll('[data-focus-id]'),
  ).filter(element => !element.getAttribute('data-focus-id')?.includes('hint'));
  const currentFocusIndex = focusableElements.findIndex(
    element => element.getAttribute('data-focus-id') === current,
  );

  let nextFocusIndex: number;
  if (to) {
    nextFocusIndex = Array.from(focusableElements).findIndex(
      element => element.getAttribute('data-focus-id') === to,
    );
  } else {
    nextFocusIndex = currentFocusIndex + 1;
  }

  const focusId =
    focusableElements[nextFocusIndex]?.getAttribute('data-focus-id');

  focusId && focusField(focusId);
};

export const goToPreviousFocusable = ({
  current,
  to,
}: {
  current: string;
  to?: string;
}) => {
  const focusableElements = Array.from(
    document.querySelectorAll('[data-focus-id]'),
  ).filter(element => !element.getAttribute('data-focus-id')?.includes('hint'));

  const currentFocusIndex = focusableElements.findIndex(
    element => element.getAttribute('data-focus-id') === current,
  );

  let previousFocusIndex: number;
  if (to) {
    previousFocusIndex = Array.from(focusableElements).findIndex(
      element => element.getAttribute('data-focus-id') === to,
    );
  } else {
    previousFocusIndex = currentFocusIndex - 1;
  }

  const focusId =
    focusableElements[previousFocusIndex]?.getAttribute('data-focus-id');

  focusId && focusField(focusId);
};
